import Hidden from './hidden.vue';

export default Hidden;


// WEBPACK FOOTER //
// ./src/components/inputs/hidden/index.js